import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const PlanningNondeterministicMultiagent = () => (
  <AIModuleSubtopic
    title="Planning and acting in Nondeterministic domains – Sensor-less Planning, Multiagent planning"
    videos={[]}
    takeaways={[
      { text: "Understand how to represent actions in STRIPS for the blocks world problem." },
      { text: "Learn about planning in nondeterministic domains and multiagent environments." }
    ]}
    questions={[
      {
        text: "Give generic representations of actions along with the preconditions and effects in STRIPS that can be used in the blocks world problem. Write a suitable plan of action to reach the goal state from the start state. b) Write a short note on planning in a nondeterministic domain.",
        image:"/ai_57.png"
      },
      {
        text: "Demonstrate various planning methods in a non-deterministic domain with suitable examples."
      },
      {
        text: "Consider a scenario where multiple autonomous robots are tasked with exploring an unknown environment and mapping its layout. Discuss the challenges and strategies involved in planning and coordinating the actions of these robots in a continuous environment."
      }
    ]}
    exampleVideos={[]}
  />
);

export default PlanningNondeterministicMultiagent;
